export type GenericComment = {
  id: number;
  comment: string;
  createdAt: Date;
  internal: boolean;
  displayName?: string;
  email?: string;
  contactId?: number;
  deletedAt?: Date;
  archivedAt?: Date;
};

export const LifecycleAction = {
  Archive: 'Archive',
  Restore: 'Restore',
  Delete: 'Delete',
} as const;

export type LifecycleActionType = (typeof LifecycleAction)[keyof typeof LifecycleAction];

export type CommentsProps = {
  inputIdSuffix?: string;
  disablePost?: boolean;
  postComment: (comment: string, internal: boolean) => void;
  updateComment?: (comment: GenericComment) => void;
  handleLifecycleClick?: (commentId: number, action: LifecycleActionType) => void;
  comments: GenericComment[];
  disabledInternalComments?: boolean;
  canModerateAllPosts?: boolean;
  contactId?: number;
};
